import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Test d'éligibilité
  testEligibility: async (data) => {
    const response = await axios.post(`${API}/eligibility/test`, data);
    return response.data;
  },

  // Contact
  sendContact: async (data) => {
    const response = await axios.post(`${API}/contact`, data);
    return response.data;
  },

  // Demande de devis
  requestQuote: async (data) => {
    const response = await axios.post(`${API}/quote`, data);
    return response.data;
  },

  // Récupérer les services
  getServices: async () => {
    const response = await axios.get(`${API}/services`);
    return response.data;
  },
};

export default api;